<!-- La date juste sous la barre d'état : la ligne de 44 px fait sa propre marge (maquette, 70 px du haut). -->
<vw-header-padding-safe-area [gap]="0"></vw-header-padding-safe-area>
<div class="px-4">
  <!-- Une ligne de 44 px : la date et la cloche (« Se connecter » pour un invité). -->
  <vw-header-home [guest]="isGuest"></vw-header-home>
  <div class="mt-1 flex flex-col gap-2 pb-2">
    <!-- Réseau coupé : l'accueil du dernier chargement, daté (NA-05) -->
    <vw-offline-banner titleKey="components.state.offline.title-time" [messageParams]="offlineParams" (retry)="load()"></vw-offline-banner>
    <!-- Nouvelle version de l'app recommandée (/app-config, NA-03) : le magasin, ou la croix jusqu'à la suivante. -->
    @if (appConfig.update() === 'recommended') {
      <vw-list-section edge="inset" data-test="app-update-line">
        <vw-list-row [title]="'app-update.recommended.title' | translate" [subtitle]="appConfig.message() ?? ('app-update.recommended.text' | translate)"
          [chevron]="false" (rowClick)="appConfig.openStore()">
          <button vwListRowAction type="button" (click)="appConfig.dismissRecommended()" [attr.aria-label]="'app-update.recommended.close' | translate"
            class="flex h-target w-target items-center justify-center text-vw-icon-idle">
            <vw-close-icon class="block h-5 w-5 [&>svg]:h-full [&>svg]:w-full" aria-hidden="true"></vw-close-icon>
          </button>
        </vw-list-row>
      </vw-list-section>
    }
    <!-- Un squelette dans l'ordre de la page (140) ; en panne du compte, une seule carte d'erreur. -->
    <vw-state [state]="pageState" (retry)="load()">
      <div skeleton class="flex flex-col gap-2">
        <vw-skeleton-loader [width]="'100%'" [height]="'211px'" [borderRadius]="'1.5rem'"></vw-skeleton-loader>
        <vw-skeleton-loader [width]="'100%'" [height]="'117px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
        <vw-skeleton-loader [width]="'100%'" [height]="'128px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
      </div>
    </vw-state>
    @if (userLoaded) {
      @if (isGuest) {
        <!-- Invité : sa commune et deux cultures donnent le message de ce matin. -->
        <vw-guest-trial></vw-guest-trial>
      } @else if (firstLaunch && !firstLaunchLater) {
        <vw-first-launch [done]="firstLaunchDone" [commune]="advice?.address?.city ?? null" [setup]="setup" (later)="onFirstLaunchLater()"></vw-first-launch>
        @if (showBand) {
          <vw-weather-moon-band [weather]="bandWeather" [moon]="bandMoon" [stale]="bandStale"
            (openWeather)="openWeather()" (openMoon)="openMoon()"></vw-weather-moon-band>
        }
      } @else {
        <!-- Le mot du jour, la bande météo et lune juste dessous, puis deux gestes au plus et la quinzaine. -->
        <vw-day-board [choice]="choice" [tasksCount]="tasksCount">
          @if (showBand) {
            <vw-weather-moon-band vwDayBoardBand class="mt-2 block" [weather]="bandWeather" [moon]="bandMoon"
              [stale]="bandStale" [suppressSignals]="suppressedSignals" (openWeather)="openWeather()" (openMoon)="openMoon()">
            </vw-weather-moon-band>
          }
        </vw-day-board>
        <!-- Une seule accroche, après les gestes : on vend une fois la valeur montrée. -->
        @if (showTeasers && choice?.head) {
          <vw-premium-teaser [line]="true" [message]="'home.premium.band' | translate" source="home_band"
            (ctaClicked)="openPaywall($event)"></vw-premium-teaser>
        }
        <!-- Sous la carte du jour, jamais au-dessus : les cultures qui semblent finies, proposées au rangement. -->
        <vw-finished-plants [openRequest]="finishedOpenRequest"></vw-finished-plants>
      }
    }
  </div>

  <!-- Au défilé : le suivi de croissance (le titre affleure), puis les articles. -->
  @if (gddMilestones.length > 0 && !isGuest) {
    <div class="mt-4 flex flex-col gap-2">
      <vw-gdd-milestones-widget [items]="gddMilestones" [maxItems]="gddMaxItems"></vw-gdd-milestones-widget>
    </div>
  }

  <!-- Conseils du moment : trois, pas vingt. Le contenu editorial reste
       present sans monopoliser la page. -->
  @if (articles?.length > 0) {
  <div class="flex flex-col gap-4 mt-8 mb-28">
    <div class="flex items-baseline justify-between gap-3">
      <h2 class="text-title-l text-vw-ink">
        {{ "home.articles.title" | translate }}
      </h2>
      <button type="button" (click)="onAllArticles()"
        class="shrink-0 text-sm font-semibold text-primary">
        {{ 'articles.see-all' | translate }} &rsaquo;
      </button>
    </div>
    <!-- Defilement horizontal, comme les plantes : une grille faisait
         repasser le troisieme article a la ligne et doublait la hauteur de
         la section pour un article de plus. -->
    <div class="-mx-4 flex snap-x snap-mandatory scroll-pl-4 scroll-pr-4 gap-3 overflow-x-auto px-4 pb-1">
      @for (article of articles; track article) {
      <div class="w-[172px] shrink-0 snap-start">
        <vw-article [article]="article" [compact]="true"></vw-article>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="mb-28"></div>
  }
</div>

<vw-premium-toast
  [isOpen]="premiumPaywallMode"
  [source]="paywallSource"
  (close)="premiumPaywallMode = false"
></vw-premium-toast>
